module.exports = __webpack_public_path__ + "img/ge.a3287fec.png";